import Api from '../apis/Api';
import GLU from '../glu2.js/src/index';

class DealListDataSource extends GLU.DataSource {
    static get name() {
        return 'DealListDataSource';
    }

    static getInstance() {
        return new DealListDataSource();
    }

    constructor() {
        super(() => false);
        /** @type {import('../types').DealList[]} */
        this._dealLists = [];
    }

    /** @returns {import('../types').DealList[]}  */
    get dealLists() {
        return this._dealLists;
    }

    /**
     * @returns {Promise<import('../types').DealList[]>}
     */
    loadDealLists = () =>
        new Promise((resolve, reject) => {
            Api.dealList.getDealLists().then(response => {
                if (response.body) {
                    /** @type {import('../types').DealListsResponse} */
                    this.res = response.body;
                    this._dealLists = this.res.lists;
                }
                resolve(this._dealLists);
            }, reject);
        });
}

export default DealListDataSource;
